import React, { useState, useEffect } from "react";
import authStorage from "../../utils/authStorage";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../config";
import moment from "moment";

const BookSessions = ({ back }) => {
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const [currentDay, setSelectedDay] = useState('');
    const [selectedFullDate, setSelectedFullDate] = useState('');
    const [selectedSlots, setSelectedSlots] = useState('');
    const [bookedSlots, setBookedSlots] = useState([]);
    const [availableSlots, setAvailableSlots] = useState([]);
    const [calendarEvents, setCalendarEvents] = useState({});
    const [bookedTrainingSessions, setBookedTrainingSessions] = useState([]);
    const [paymentDetail, setPaymentDetail] = useState();
    const [trainingSessionDetail, setTrainingSessionDetail] = useState({
        total: 0,
        booked: 0,
        remaining: 0,
    });

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);

    useEffect(() => {
        let subscribedStatus = authStorage.getItem('subscribedStatus');

        // If subscribedStatus is falsy, redirect to membership page
        if (subscribedStatus == 'false') {
            window.location = window.location.origin + '/membership';
            return false;
        }
    }, []);

    const daysInMonth = (month, year) => {
        return new Date(year, month, 0).getDate();
    };

    const getMonthName = (month) => {
        const monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        return monthNames[month - 1];
    };

    const monthDays = daysInMonth(currentMonth, currentYear);
    const firstDay = new Date(currentYear, currentMonth - 1, 1).getDay();
    const weeks = Math.ceil((monthDays + firstDay) / 7);

    const days = [];
    for (let i = 1; i <= weeks * 7; i++) {
        if (i > firstDay && i <= monthDays + firstDay) {
            days.push(i - firstDay);
        } else {
            days.push(null);
        }
    }

    const handlePreviousMonth = () => {
        if (currentMonth === 1) {
            setCurrentMonth(12);
            setCurrentYear(currentYear - 1);
        } else {
            setCurrentMonth(currentMonth - 1);
        }
    };

    const handleNextMonth = () => {
        if (currentMonth === 12) {
            setCurrentMonth(1);
            setCurrentYear(currentYear + 1);
        } else {
            setCurrentMonth(currentMonth + 1);
        }
    };

    const handlePreviousYear = () => {
        setCurrentYear(currentYear - 1);
    };

    const handleNextYear = () => {
        setCurrentYear(currentYear + 1);
    };

    const confirmTrainingSessionBooking = () => {
        let sessionToUpdate = {};
        setSubmitLoading(true);
        let bookedTrainingSession=0;let totalTrainingSession=0;
        bookedTrainingSessions?.forEach((data) => {
            totalTrainingSession = totalTrainingSession + parseInt(data?.sessions);
            // let bookedTrainingSession = data?.sessionTiming?.length;
            data?.sessionTiming?.filter((timing) => !timing.cancelByAdmin).forEach(() => {
                bookedTrainingSession++;
              });
            let remainingTrainingSession = totalTrainingSession - bookedTrainingSession;
            // console.log("remaining training session : ",remainingTrainingSession,"tot",totalTrainingSession,"book",bookedTrainingSession)
            if (remainingTrainingSession > 0) {
                let removedArray = bookedSlots.splice(-remainingTrainingSession, remainingTrainingSession);
                sessionToUpdate[data?._id] = removedArray;
            }
        });
        for (let index in sessionToUpdate) {
            if (sessionToUpdate[index].length >= 1) {
                axios({
                    headers: {
                        "x-access-token": authStorage.getItem("auth-token")
                    },
                    url: `${BASE_URL}/user/training/slots`, // your url
                    method: 'put',
                    data: { id: index, sessionSlots: sessionToUpdate[index] }
                }).then((res) => {
                    console.log("function call", res)
                    getTrainingSession();
                });
            }
            setTimeout(() => {
                navigate('/Training');
            }, 500);
        }
    };

    const getTrainingSession = () => {
        setLoading(true);
        axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            },
            url: `${BASE_URL}/user/training/session`, // your url
            method: 'get',
        }).then((res) => {
            setBookedTrainingSessions(res?.data?.data || []);
            setLoading(false);
        });
    };

    const addSlots = (slot) => {
        if (bookedSlots.length >= trainingSessionDetail?.remaining) {
            return;
        }
        let slots = [...bookedSlots];
        const slotExists = slots.find((s) => s.id === slot.id);
        if (!slotExists) {
            slots.push(slot);
            setBookedSlots(slots);
            setSelectedDay('');
        }
    };

    const removeSlots = (slotToRemove) => {
        let slots = bookedSlots.filter((slot) => slot.id !== slotToRemove.id);
        setBookedSlots(slots);
    };

    useEffect(() => {
        getTrainingSession();
    }, [location]);

    useEffect(() => {
        if (!selectedFullDate) {
            return;
        }
        setLoading(true);
        axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            },
            url: `${BASE_URL}/user/training/available/session/${selectedFullDate}`, // your url
            method: 'get',
        }).then((res) => {
            setAvailableSlots(res?.data?.data);
            setLoading(false);
        });
    }, [currentDay, selectedFullDate]);

    const onClickDate = (day, currentFullDate) => {
        if (moment(currentFullDate).isBefore(moment())) {
            setError('Please Select Future Dates');
            setTimeout(() => {
                setError('');
            }, 3000);
            return;
        }
        setSelectedDay(day);
        setSelectedFullDate(currentFullDate);
    };

    const handleSlotSelection = (data) => {
        setSelectedSlots(data);
        addSlots({ date: selectedFullDate, time: { startTime: data?.startTime, endTime: data?.endTime }, id: data?._id });
    };

    useEffect(() => {
        let totalTrainingSession = 0;
        let bookedTrainingSession = 0;
        bookedTrainingSessions?.forEach((data) => {
            totalTrainingSession = totalTrainingSession + parseInt(data?.sessions);
            // bookedTrainingSession = bookedTrainingSession + data?.sessionTiming?.length;
            data?.sessionTiming?.filter((timing) => !timing.cancelByAdmin).forEach(() => {
                bookedTrainingSession++;
              });
        });
        setTrainingSessionDetail({
            total: totalTrainingSession,
            booked: bookedTrainingSession,
            remaining: totalTrainingSession - bookedTrainingSession
        });
    }, [bookedTrainingSessions]);

    return (
        <div className="min-h-screen md:mx-10 md:h-auto mt-5">
            <div className="justify-center mb-8 p-4 md:p-6 bg-white rounded-lg md:mx-0 mx-2">
                <div className="px-1">
                    <div className="flex justify-between mb-4">
                        <span className="text-md md:text-xl text-[#E53E14] dark:text-white">Your Training Sessions</span>
                        <div>
                            <span className="text-md md:text-xl text-[#E53E14] dark:text-white">{trainingSessionDetail?.booked}/</span>
                            <span className="text-md md:text-xl text-[#2995F7] dark:text-white">{trainingSessionDetail?.total}</span>
                        </div>
                    </div>
                    <div className="w-full bg-[#2995F7] rounded-full h-2 dark:bg-gray-700">
                        <div className="bg-[#E53E14] h-2 rounded-full" style={{ width: `${((trainingSessionDetail?.booked / trainingSessionDetail?.total) * 100)}%` }}></div>
                    </div>
                    <div className="mt-5 text-lg font-light text-black">
                        Please book your remaining session
                    </div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row justify-center md:gap-0 gap-4 md:mx-0 mx-2">
                {currentDay ? (
                    <div className="md:w-[60%] bg-white px-4 py-6 rounded-lg">
                        <div className="flex justify-center text-gray-900 mb-5">Please Select Slot - {moment(selectedFullDate).format('DD MMM YYYY')}</div>
                        <div className="flex justify-center flex-wrap text-gray-400">
                            {!loading &&
                                (availableSlots?.length > 0) ?
                                (
                                    availableSlots.map(data => (
                                        <div key={data?.startTime} onClick={() => handleSlotSelection(data)} className={`text-sm text-black p-2 m-1 bg-[#FFF5F3] ${(selectedSlots?.startTime === data?.startTime) && ' border '} p-2 m-1 cursor-pointer`}>
                                            {data.startTime} - {data.endTime}
                                        </div>
                                    ))
                                ) : (
                                    <div className="my-10">
                                        No Slots Available, Please select Another Date
                                    </div>
                                )
                            }
                        </div>

                        <div className="flex justify-center py-4 mt-5">
                            <button onClick={() => setSelectedDay('')} className="mx-2 inline-flex w-[100px] items-center justify-center rounded py-2 px-4 text-[#2995F7] hover:text-opacity-100 bg-white border-1 border-[#2995F7]">
                                Back
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="md:w-[60%] bg-white pt-6 rounded-lg">
                        <div className="flex justify-center bg-white px-4">
                            <div className="flex justify-between my-4 w-3/4 text-black bg-gray">
                                <button
                                    className="text-black px-4 py-2 rounded bg-white border-0"
                                    onClick={handlePreviousYear}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="#A8AAAD"
                                        className="w-5 h-5"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                                        />
                                    </svg>
                                </button>
                                <div
                                    className="text-md uppercase font-medium"
                                    style={{ marginTop: "5px" }}
                                >
                                    {currentYear}
                                </div>
                                <button
                                    className="text-black px-4 py-2 rounded bg-white border-0"
                                    onClick={handleNextYear}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="#A8AAAD"
                                        className="w-5 h-5"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div className="flex justify-between my-4 w-3/4 text-gray-500 bg-gray">
                                <button
                                    className="text-black px-4 py-2 rounded bg-white border-0"
                                    onClick={handlePreviousMonth}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="#A8AAAD"
                                        className="w-5 h-5"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                                        />
                                    </svg>
                                </button>
                                <div
                                    className="text-black px-4 py-2 rounded bg-white border-0"
                                    style={{ marginTop: "5px" }}
                                >
                                    {getMonthName(currentMonth)}
                                </div>
                                <button
                                    className="text-black px-4 py-2 rounded bg-white border-0"
                                    onClick={handleNextMonth}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="#A8AAAD"
                                        className="w-5 h-5"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div className="flex flex-wrap mt-2 p-4">
                            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                                <div
                                    key={day}
                                    className="w-[14.1867%] text-black text-center font-medium mb-2 bg-[#FFF5F3] p-3"
                                >
                                    {day}
                                </div>
                            ))}
                            {days.map((day, index) => {
                                let currentFullDate = `${currentYear}-${currentMonth?.toString().padStart(2, "0")}-${day?.toString().padStart(2, "0")}`;

                                let isCurrentDate =
                                    day === new Date().getDate() &&
                                    currentMonth === new Date().getMonth() + 1 &&
                                    currentYear === new Date().getFullYear();
                                let currentHeartData = {};
                                calendarEvents?.[day]?.forEach(data => {
                                    currentHeartData[data?.heartZoneName?.toLowerCase() || 'unknown'] = data;
                                });

                                return (
                                    <div
                                        onClick={() => onClickDate(day, currentFullDate)}
                                        key={index}
                                        className={`w-[14.1867%]  ${day && 'cursor-pointer'} text-sm text-gray-600 border border-theme-blue text-center ${(currentDay === day) ? "bg-white" : "bg-white"}`}
                                    >
                                        <div className="p-4 md:py-2">
                                            <div className="flex justify-center">
                                                <div
                                                    className={`${isCurrentDate
                                                        ? "text-[#2995F7]"
                                                        : "text-black"
                                                        } rounded w-6`}
                                                >
                                                    {day}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className={`bg-[#F3F3F3] py-3 text-sm text-black text-center text-${error ? 'red-500' : 'black'} text-center`}>{error ? error : 'Please Select Date'}</div>
                    </div>
                )}
                <div className="md:ml-10 ml-0 md:w-[40%] bg-white p-4 text-black rounded-lg">
                    <div className="my-2 capitalize">slots</div>
                    <div className="h-64 overflow-y-scroll">
                        {bookedSlots?.map(data => (
                            <div className="flex justify-between p-4 bg-slate-50 my-3 rounded-sm">
                                <div className="pr-4">{moment(data.date).format('DD MMM YYYY')} {data.time?.startTime} - {data.time?.endTime}</div>
                                <div className="cursor-pointer" onClick={() => removeSlots(data)}>
                                    <svg className="cursor-pointer h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="flex justify-center py-8">
                <button onClick={() => { confirmTrainingSessionBooking(); back(8) }} type="submit" className="mx-2 inline-flex w-[200px] items-center justify-center bg-[#E53E14] border-1 border-white p-3 text-white hover:text-opacity-100 rounded-lg">
                    <div className="mr-3">Confirm Booking</div>
                    {submitLoading && (
                        <svg aria-hidden="true" role="status" className="inline w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                        </svg>
                    )}
                </button>
                <button onClick={() => { navigate('/Training'); back(8) }} type="submit" className="mx-2 inline-flex w-[200px] items-center justify-center rounded py-2 px-4 text-[#E53E14] bg-white border-1 border-[#E53E14]">
                    Back
                </button>
            </div>
        </div >
    );
}

export default BookSessions;
